module.exports = __webpack_public_path__ + "static/media/nutricia-brand-allergens-mustard.34c36440.svg";